import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";

type IDepositWarningModalProps = {
  open: boolean;
  onClose: () => void;
  submit: () => void;
};

export const DepositWarningModal = ({
  open,
  onClose,
  submit,
}: IDepositWarningModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        maxWidth: "550px",
        margin: "0 auto",
      }}
    >
      <DialogContent
        sx={{
          backgroundColor: "var(--secondary-background-color)",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            border: "2px solid var(--primary-color) !important",
            borderRadius: "var(--primary-border-radius)",
            padding: "2px 6px",
          }}
        >
          <Typography
            variant="body1"
            component="p"
            sx={{
              fontSize: "20px",
              fontWeight: "800 !important",
              color: "var(--primary-text-color)",
              marginBottom: "20px",
            }}
          >
            Внимание!
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{
              fontSize: "16px",
              fontWeight: "400 !important",
              color: "var(--primary-text-color)",
              marginBottom: "20px",
            }}
          >
            Сумма платежа может изменится на странице платежной системы.
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{
              fontSize: "16px",
              fontWeight: "800 !important",
              color: "var(--primary-text-color)",
              marginBottom: "20px",
            }}
          >
            Нужно перевести именно ту сумму, которая будет там указана, в ином
            случае, средства будут утеряны
          </Typography>
        </Box>
        <Button
          sx={{
            backgroundColor: "var(--secondary-background-color)",
            marginTop: "20px",
            textDecoration: "underline",
            color: "var(--primary-color)", // червоний текст
            fontSize: "14px",
            fontWeight: "400",
            textTransform: "none",
            "&:hover": {
              color: "var(--primary-color-hover)",
              backgroundColor: "var(--secondary-background-color)",
              textDecoration: "underline",
            },
          }}
          onClick={submit}
        >
          Принять и продолжить
        </Button>
      </DialogContent>
    </Dialog>
  );
};
